import { useContext } from "react";
import { CardDeck, Container, Modal, Row } from "react-bootstrap";

import ProviderCard from "./providerCard";

import { W3Context } from "../../services/context";

import { providers } from "../../Constants";

import "./walletSelectorStyles.css";

const METAMASK_DOWNLOAD_URL = "https://metamask.io/download.html";

const WalletSelector = ({ displayModal, setDisplayModal }) => {
  const {
    active,
    account,
    library,
    connector,
    connectInjected,
    connectWalletConnect,
    disconnect,
  } = useContext(W3Context);

  const connectMapper = (connectionType) => {
    if (!active) {
      switch (connectionType) {
        case "MetaMask":
          return connectInjected();
        case "Wallet Connect":
          return connectWalletConnect();
        case "Trust Wallet":
          return connectWalletConnect();
      }
    }
  };

  return (
    <Modal
      size="lg"
      show={displayModal}
      onHide={() => setDisplayModal(false)}
      centered
    >
      <Modal.Header closeButton className="wallet-selector-header">
        <Modal.Title className="wallet-selector-title mx-auto">
          Connect your Wallet
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="wallet-selector-body">
        <Container className="wallet-selector-container">
          <Row className="wallet-selector-row mx-auto text-center justify-content-center">
            <CardDeck className="wallet-selector-deck justify-content-center">
              {providers.map((provider, index) => (
                <ProviderCard
                  key={index}
                  name={provider.name}
                  logo={provider.logo}
                  onClick={() => connectMapper(provider.name)}
                />
              ))}
            </CardDeck>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer className="wallet-selector-footer">
        <Container>
          <Row xs={12} className="justify-content-center">
            <span className="wallet-selector-footer-text">
              Haven't got a crypto wallet yet?
            </span>
          </Row>
          <Row>
            <button
              className="wallet-selector-footer-button mx-auto"
              onClick={() => window.open(METAMASK_DOWNLOAD_URL)}
            >
              Learn How to Connect
            </button>
          </Row>
        </Container>
      </Modal.Footer>
    </Modal>
  );
};

export default WalletSelector;
